const DateTimeOptions = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
};
const DateOptions = { year: "numeric", month: "numeric", day: "numeric" };

const _twoDigitsFormat = (x) => {
  x = parseInt(x) || 0;
  return ("0" + x).slice(-2);
};

const _getLocalDateParts = (d) => {
  const date = `${d.getFullYear()}-${_twoDigitsFormat(
    d.getMonth() + 1
  )}-${_twoDigitsFormat(d.getDate())}`;
  const time = `${_twoDigitsFormat(d.getHours())}:${_twoDigitsFormat(
    d.getMinutes()
  )}`;
  return { date, time };
};

const _getLaravelDateTime = (d) => {
  const iso = d.toISOString();
  return iso.split("T").join(" ").split(".")[0];
};

///get date object from laravel date/time
const _getDateObject = (value) => {
  ///check if already in UTC format
  let utc = undefined;
  if (value && value.slice(-1) == "Z") {
    utc = value;
  } else if (value) {
    const [date, time] = value.split(" ");
    let [hr, min, sec] = time.split(":");
    hr = _twoDigitsFormat(hr);
    min = _twoDigitsFormat(min);
    sec = _twoDigitsFormat(sec);
    utc = `${date}T${hr}:${min}:${sec}Z`;
  } else {
    throw new Error("Invalid Date/Time format");
  }
  return new Date(utc);
};

export default {
  filters: {
    /////filter local date from laravel dateTime
    filterLocalDate(value) {
      try {
        return _getDateObject(value).toLocaleDateString("en-CA", DateOptions);
      } catch (err) {
        return "";
      }
    },
    /////filter local date/time from laravel dateTime
    filterLocalDateTime(value) {
      try {
        return _getDateObject(value).toLocaleString("en-CA", DateTimeOptions);
      } catch (err) {
        return undefined;
      }
    },
  },
  methods: {
    getDateObject(value) {
      return _getDateObject(value);
    },
    /////display local date only from laravel dateTime
    displayLocalDate(value) {
      try {
        return _getDateObject(value).toLocaleDateString("en-CA", DateOptions);
      } catch (err) {
        return "";
      }
    },
    /////display local date/time from laravel dateTime
    displayLocalDateTime(value) {
      try {
        return _getDateObject(value).toLocaleString("en-CA", DateTimeOptions);
      } catch (err) {
        return undefined;
      }
    },

    // display local date/time of Date Object
    displayObjectDateTime(dateObject) {
      try {
        return dateObject.toLocaleString("en-CA", DateTimeOptions);
      } catch (err) {
        return undefined;
      }
    },

    getLaravelDateTime(d) {
      d = d || new Date();
      return _getLaravelDateTime(d);
    },

    //get Laravel datetime from Local date and time
    getLaravelFrLocalParts(date, time) {
      try {
        if (!date || !time) throw new Error("Invalid date/time");
        let [year, month, day] = date.split("-");
        let [hour, minute] = time.split(":");
        year = parseInt(year);
        month = parseInt(month) - 1;
        day = parseInt(day);
        hour = parseInt(hour);
        minute = parseInt(minute);
        //set local date/time
        const d = new Date(year, month, day, hour, minute);
        return _getLaravelDateTime(d);
      } catch (err) {
        return undefined;
      }
    },

    //get Laravel datetime from Local year,month,date,hour and minutes
    getLaravelFrLocalYYMMDDhhmm(year, month, day, hour, minute) {
      try {
        const d = new Date(year, month, day, hour, minute);
        return _getLaravelDateTime(d);
      } catch (err) {
        return undefined;
      }
    },

    //get Local date and time from Laravel datetime
    getLocalPartsFrLaravelDt(value) {
      try {
        console.log("laravel dateTime:", value);
        const d = _getDateObject(value);
        return _getLocalDateParts(d);
      } catch (err) {
        ////throw new Error("Invalid DateTime")
        return { date: undefined, time: undefined };
      }
    },
  },
};
